// extracted by mini-css-extract-plugin
module.exports = {"number":"Number_number__RvWbW"};